import { schema } from 'normalizr';

export const profitItemDefSchema = new schema.Entity('profitItemDefs');
